export default "__VITE_PUBLIC_ASSET__cb6bf645__"